export const Brand = {
  name: 'Facade Leads',
  tagline: 'Marketing for facade installers and manufacturers',
  description: 'We help facade installers and manufacturers win more work with marketing built for the building envelope industry.',
};